import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Breadcrumb, Card, Form, Container, CardBody, CardHeader } from "react-bootstrap";
import { Avatar } from 'primereact/avatar';
import { Image } from 'primereact/image';
import { Timeline } from 'primereact/timeline';
import ticket from '../assets/images/not-found.png';
import { Button } from 'primereact/button';
import { InputTextarea } from "primereact/inputtextarea";
import api from "../api/axios";
const Report_data = ({ ticketId }) => {
    const [ticket, setTicket] = useState(null);
    const [events, setEvents] = useState([]);
    const [message, setMessage] = useState("");
    const [images, setImages] = useState([]);
    const fileInputRef = useRef(null);
    const chatContainerRef = useRef(null);

    // Select images
    /* ================= SELECT IMAGES ================= */
    const handleImageSelect = (e) => {
        const files = Array.from(e.target.files);

        const previews = files.map((file) => ({
            file,
            url: URL.createObjectURL(file)
        }));

        setImages(previews);
    };

    /* ================= SEND MESSAGE ================= */
    const sendMessage = async () => {
        if (!message.trim()) return;

        try {
            const formData = new FormData();
            formData.append("message", message);

            images.forEach((img) => {
                formData.append("attachments", img.file);
            });

            await api.post(
                `/ctickets/add_ticket_comment/${ticketId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            setMessage("");
            setImages([]);

            fetchTicket(); // 🔄 refresh messages

        } catch (error) {
            console.error("Send Message Error:", error);
        }
    };


    /* ================= FETCH TICKET ================= */
    const fetchTicket = async () => {
        try {
            const res = await api.get(`/ctickets/get_ticket/${ticketId}`);
            const ticketData = res.data.data;

            setTicket(ticketData);

            // Format messages for timeline
            const formattedMessages = ticketData.messages.map((msg) => ({
                text: msg.message,
                date: new Date(msg.createdAt).toLocaleString(),
                senderType: msg.sender_type, // 🔥 important
                user:
                    msg.sender_type === "Customer"
                        ? "You"
                        : "Admin",
                attachments: msg.attachments || []
            }));

            setEvents(formattedMessages);

        } catch (error) {
            console.error("Fetch Ticket Error:", error);
        }
    };

    useEffect(() => {
        if (ticketId) fetchTicket();
    }, [ticketId]);
    /* ================= AUTO SCROLL ================= */
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: "smooth"
            });
        }
    }, [events]);



    if (!ticket) return <div>Loading...</div>;

    return (
        <>
            <div className="d-flex justify-content-between align-items-start gap-2 flex-column">
                <Card className='reportcard overflow-hidden w-100'>
                    <CardBody>
                        <Row className="mx-0">
                            {/*<Col lg={5} xs={12} className="p-0 pe-2">
                                <Image
                                    src={ticket}
                                    alt="Ticket"
                                    width="100%"
                                    height="100%"
                                    preview
                                /> 
                            </Col>*/}
                            <Col lg={12} xs={12} className="p-0 ps-2 childReport">
                                <p className='mb-1'>Title : <b>{ticket.title}</b></p>
                                <p className='mb-1'>Id : <b>{ticket.ticket_no}</b></p>
                                <p className='mb-1'>Category : <b>{ticket.category}</b></p>
                                <p className="d-flex gap-2 align-items-center mb-1">
                                    Assigned To :
                                    {ticket.resolver ? (
                                        <span className="d-flex gap-2 align-items-center">
                                            <Avatar
                                                label={ticket.resolver.first_name?.[0]}
                                                style={{
                                                    backgroundColor: "#9c27b0",
                                                    color: "#fff",
                                                    width: "28px",
                                                    height: "28px"
                                                }}
                                                shape="circle"
                                            />
                                            <b>
                                                {ticket.resolver.first_name} {ticket.resolver.last_name}
                                            </b>
                                        </span>
                                    ) : (
                                        <b> Not Assigned</b>
                                    )}
                                </p>
                                <p className='mb-1'>Description :
                                    <span className="text-light d-block" style={{ lineHeight: '22px' }}>{ticket.issue}</span>
                                </p>
                                {ticket.images?.length > 0 && (
                                    <div className="d-flex gap-2 align-items-start justify-content-start mt-3">
                                        {ticket.images.map((img) => (
                                            <Image
                                                key={img.Ticket_image_id}
                                                src={img.image_url_ticket}
                                                width="70"
                                                preview
                                            />
                                        ))}
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <div className={`offerBadge bg-${ticket.status === "Solved" ? "success" : "yellow"}`}>
                            <i
                                className="pi pi-check me-1"
                                style={{ fontSize: "1rem" }}
                            ></i>
                            {ticket.status}
                        </div>
                    </CardBody>
                </Card>
                <hr />
                {/* Chat list */}
                {/* <div className="customtimeline" style={{ height: "50vh", overflowY: "auto" }}>
                    <Timeline
                        value={events}
                        content={(item) => (
                            <div className={`d-flex flex-column gap-2 ${item.senderType === "Customer"
                                    ? "align-items-end text-end"
                                    : "align-items-start"
                                }`}>
                                <span>{item.text}</span>

                                {item.attachments?.length > 0 && (
                                    <div className="d-flex gap-2 flex-wrap mt-2">
                                        {item.attachments.map((file, i) => (
                                            <Image
                                                key={i}
                                                src={file.file_url}
                                                width="80"
                                                preview
                                            />
                                        ))}
                                    </div>
                                )}


                                <small>
                                    {item.date} | By <b>{item.user}</b>
                                </small>
                            </div>
                        )}
                    />
                </div> */}
                <div  ref={chatContainerRef} className="customtimeline w-100" style={{ height: "41vh", overflowY: "auto" }}>
                    {events.map((item, index) => (
                        <div
                            key={index}
                            className={`d-flex mb-3 ${item.senderType === "Customer"
                                ? "justify-content-end"
                                : "justify-content-start"
                                }`}
                        >
                            <div
                                className="p-2 rounded"
                                style={{
                                    maxWidth: "70%",
                                    background:
                                        item.senderType === "Customer" ? "#ffd9ed" : "#fff"
                                }}
                            >
                                

                                {item.attachments?.length > 0 && (
                                    <div className="d-flex gap-2 flex-wrap mt-2">
                                        {item.attachments.map((file, i) => (
                                            <Image
                                                key={i}
                                                src={file.file_url}
                                                width="28"
                                                preview
                                            />
                                        ))}
                                    </div>
                                )}
                                <span className="py-2">{item.text}</span>

                                <small className="d-block mt-1">
                                    {item.date} | By <b>{item.user}</b>
                                </small>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="chatfild">
                    {/* Selected preview */}
                    {images.length > 0 && (
                        <div className="d-flex gap-2 p-2 flex-wrap">
                            {images.map((img, i) => (
                                <div key={i} className="position-relative">
                                    <img src={img.url} height="50" alt="" />

                                    {/* Remove button */}
                                    <i
                                        className="pi pi-times"
                                        style={{
                                            position: "absolute",
                                            top: "-6px",
                                            right: "-6px",
                                            cursor: "pointer",
                                            background: "#fff",
                                            borderRadius: "50%",
                                            padding: "2px",
                                            fontSize: "12px"
                                        }}
                                        onClick={() => {
                                            const updated = images.filter((_, index) => index !== i);
                                            setImages(updated);
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Input section */}
                    <div className="p-inputgroup flex-1 inputsection">
                        <input
                            type="file"
                            multiple
                            hidden
                            ref={fileInputRef}
                            accept="image/*"
                            onChange={handleImageSelect}
                        />

                        <Button
                            icon="pi pi-images"
                            text
                            severity="warning"
                            onClick={() => fileInputRef.current.click()}
                        />

                        <InputTextarea
                            placeholder="Type message..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            rows={2}
                            autoResize
                        />

                        <Button
                            icon="pi pi-send"
                            severity="warning"
                            onClick={sendMessage}
                            text
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Report_data